import { FP_APP_URL } from '@/constants/Config';

export const buildAuthRedirectUrl = (search: string): string => {
  const params = new URLSearchParams(search);
  const paramString = params.toString();

  return paramString ? `${FP_APP_URL}login?${paramString}` : FP_APP_URL;
};

/** Avoid `window.location.replace` loops when login URL resolves to this app (local dev). */
export const shouldPerformAuthRedirect = (redirectUrl: string): boolean => {
  try {
    const target = new URL(redirectUrl);
    const current = new URL(window.location.href);

    if (target.href === current.href) {
      return false;
    }

    if (target.origin === current.origin) {
      return false;
    }

    return true;
  } catch {
    return true;
  }
};
